import React, { useState } from "react";
import { Form, Input, Button, Typography, Divider, Spin, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import PageRoutes from "../../utils/routes";
import { Card } from "antd";
import useAuthService from "../../services/useAuthService";

const SIGNUP_URL =
  "https://hemenpersonel-api.anemotech.com/personnel/auth/registerWeb";

const SignUpPersonnel = () => {
  const [form] = useForm();
  const navigate = useNavigate();
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();

  const {
    personnelRegister: { mutate: personnelRegister, isLoading },
  } = useAuthService();

  // Form submit handler
  const onSubmit = (values) => {
    const requestBody = {
      name: values.name,
      surname: values.surname,
      email: values.email,
      countryCode: 90,
      phoneNumber: values.phoneNumber,
      password: values.password,
      confirmPassword: values.confirmPassword,
    };
    personnelRegister(requestBody);
  };

  return (
    <>
      <Card
        style={{
          maxWidth: 750,
          margin: "40px auto",
          padding: "24px",
          boxShadow: "0px 5px 15px hsla(220, 30%, 5%, 0.05)",
        }}>
        <Typography.Title level={2} style={{ textAlign: "center" }}>
          Kayıt Ol
        </Typography.Title>
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label="İsim"
                name="name"
                rules={[
                  { required: true, message: "Lütfen isminizi giriniz" },
                ]}>
                <Input placeholder="İsim" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="Soyisim"
                name="surname"
                rules={[
                  { required: true, message: "Lütfen soyisminizi giriniz" },
                ]}>
                <Input placeholder="Soyisim" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Telefon"
                name="phoneNumber"
                rules={[
                  {
                    required: true,
                    message: "Lütfen telefon numaranızı giriniz",
                  },
                ]}>
                <Input placeholder="Telefon" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="E-mail"
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Lütfen geçerli bir e-mail adresi girin",
                  },
                ]}>
                <Input placeholder="kullanıcı@örnek.com" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Şifre"
                name="password"
                rules={[
                  { required: true, message: "Lütfen şifrenizi giriniz" },
                ]}>
                <Input.Password placeholder="Şifre" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="Şifrenizi Tekrar Giriniz"
                name="confirmPassword"
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "Lütfen şifrenizi tekrar giriniz",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Şifreler eşleşmiyor"));
                    },
                  }),
                ]}>
                <Input.Password placeholder="Şifrenizi Tekrar Giriniz" />
              </Form.Item>
            </Col>
          </Row>

          <Button
            style={{ marginTop: 25 }}
            type="primary"
            htmlType="submit"
            loading={isLoading}
            block>
            Kayıt Ol
          </Button>
        </Form>

        <Divider>veya</Divider>

        <Typography.Text style={{ display: "block", textAlign: "center" }}>
          Zaten bir hesabınız var mı?{" "}
          <Button type="link" onClick={() => navigate(PageRoutes.login)}>
            Giriş yapın
          </Button>
        </Typography.Text>
      </Card>

      <ModalComponent />
    </>
  );
};

export default SignUpPersonnel;
